@if (control$$()) {
    <div #field class="rich-text-field" [class.fullscreen]="fullscreen$$()">
        @if (input_label$$()) {
            <label class="field-label">{{input_label$$()}}:</label>
        }

        @if (readonly$$()) {
            <!-- Alleen-lezen: Angular saneert de string-binding op [innerHTML] automatisch
                 (houdt opmaak, weert scripts), dus geen Quill-instance nodig. [value] gaat vóór
                 zodat een latere input-wijziging (asynchrone model-load) reactief doorwerkt;
                 de control-waarde blijft de fallback voor [control]-consumers. -->
            <div class="rt-readonly" [innerHTML]="value$$() ?? control$$().value"></div>
        } @else {
            <div #editorHost class="rt-editor"
                [style.min-height]="input_minHeight$$()"
                [style.max-height]="input_maxHeight$$()"
            ></div>
        }

        @if (control$$().invalid && errorShow$$()) {
            <mat-error>{{errorMessage_getFirst()}}</mat-error>
        }
    </div>
}
